import { Reducer } from "@ctra/utils";

import { HerdGroupList } from "./typings";
import { types as farmTypes } from "../farms";
import { types as askIdaTypes } from "../ask-ida";
import { cleanup } from "../../utils/reducer";
import { NormalizedFarmList } from "../farms/schemas";
import { NormalizedQnAList } from "../ask-ida/schema";

export const initialState: HerdGroupList = {};

/**
 * Herd group reducer
 * @param state
 * @param action
 */
const reducer: Reducer<HerdGroupList> = (state, action) => {
  const { type, payload } = action;

  switch (type) {
    case farmTypes.FETCH_FARM_LIST.fulfilled: {
      const {
        entities: { herdGroup }
      } = payload as NormalizedFarmList;

      return {
        ...state,
        ...herdGroup
      };
    }
    case askIdaTypes.FETCH_ASK_IDA_TRACKER.fulfilled: {
      const {
        entities: { herdGroup }
      } = payload as NormalizedQnAList;

      return {
        ...state,
        ...herdGroup
      };
    }
  }

  return state;
};

export default cleanup<HerdGroupList>(initialState)(reducer);
